import SelectAllButton from '../../common/components/List/SelectAllButton.js'
import {setSelectedReferenceIDs} from './moListActions.js'
import {
  referenceIDListSelector,
  indeterminateSelectedSelector,
  allSelectedSelector,
} from './moListSelectors.js'
import {useSelector} from '../../store.js'

export default function MOSelectAllButton() {
  const referenceIDList = useSelector(referenceIDListSelector)
  const indeterminate = useSelector(indeterminateSelectedSelector)
  const checked = useSelector(allSelectedSelector)

  return (
    <SelectAllButton
      checked={checked}
      indeterminate={indeterminate}
      onChange={(value) =>
        setSelectedReferenceIDs(value ? referenceIDList : [])
      }
    />
  )
}
